__turbopack_context__.v({
  "cardHeader": "SequenceSelection-module__SJvKEW__cardHeader",
  "cardHeaderCollapsible": "SequenceSelection-module__SJvKEW__cardHeaderCollapsible",
  "descriptionClamped": "SequenceSelection-module__SJvKEW__descriptionClamped",
  "tag": "SequenceSelection-module__SJvKEW__tag",
  "tagList": "SequenceSelection-module__SJvKEW__tagList",
  "tagListExpanded": "SequenceSelection-module__SJvKEW__tagListExpanded",
  "topicsContent": "SequenceSelection-module__SJvKEW__topicsContent",
  "topicsHeader": "SequenceSelection-module__SJvKEW__topicsHeader",
  "topicsSection": "SequenceSelection-module__SJvKEW__topicsSection",
  "topicsSectionCollapsible": "SequenceSelection-module__SJvKEW__topicsSectionCollapsible",
  "topicsToggle": "SequenceSelection-module__SJvKEW__topicsToggle",
});
